namespace GeniuzPOS.ReportMasterData {
    export interface Report_1409Form {
    }

    export class Report_1409Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1409';
    }
}
